export const HighlightGreen10 = () => {
  return (
    <radialGradient
      id="svg-gradient-highlight-green-10"
      cx="50%"
      cy="100%"
      r="100%"
      fx="50%"
      fy="100%"
      gradientTransform="translate(0.5, 1) scale(0.8923, 1) translate(-0.5, -1)"
    >
      <stop offset="0%" stopColor="#3EEA9C" />
      <stop offset="100%" stopColor="#1AC9AA" />
    </radialGradient>
  )
}
